import { render, staticRenderFns } from "./SceneAdd.vue?vue&type=template&id=3cbca0f2&"
import script from "./SceneAdd.vue?vue&type=script&lang=js&"
export * from "./SceneAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports